const secondary = {
    social_bind_with: '綁定到已有帳戶？使用 {{methods，list(type：disjunction;)，zhOrSpaces}} 登入並綁定。',
};
export default Object.freeze(secondary);
